.collapsible-list-section-sub-header {
  width: 100%;
  background-color: var(--light--container--background-color--1);
  overflow: auto;
  flex: 1;
  border-radius: inherit;
}
